module.exports = __webpack_public_path__ + "static/img/shishiliucheng.350b22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/gongchengshi/shishiliucheng.png
// module id = 2i50
// module chunks = 6